import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Badge } from "@mui/material";
import { useNavigate, useLocation, Routes, Route } from "react-router-dom";
import MyAds from "./MyAds/Index";
import Profile from "./Profile/Index";
import Dashboard from "./Dashboard";
import Favorites from "./MyAds/Favorites/Favorites";
import UserManagement from "./SuperAdminDashboard/UserManagement/UserManagement";
import CategoryManagement from "./SuperAdminDashboard/CategoryManagement";
import AdsManagement from "./SuperAdminDashboard/AdsManagement/AdsManagement";
import Inbox from "./Inbox/Index";
import Notifications from "./Notifications/Index";
import Offers from "./Offers/Offers";
import WhatsNew from "./WhatsNew";
import SearchesManagement from "./SuperAdminDashboard/SearchesManagement/SearchesManagement";
import DeletedAdsManagement from "./SuperAdminDashboard/AdsManagement/DeletedAdsManagement";
import ServicesManagement from "./SuperAdminDashboard/ServicesManagement/ServicesManagement";
import ServiceProvidersManagement from "./SuperAdminDashboard/ServiceProvidersManagement/ServiceProvidersManagement";
import MyServices from "./MyServices/MyServices";
import IDsManagement from "./SuperAdminDashboard/IDsManagement";
import BlogsManagement from "./SuperAdminDashboard/BlogsManagement/Index";
import ContactFormEntriesManagement from "./SuperAdminDashboard/ContactFormEntriesManagement";
import SubscribersManagement from "./SuperAdminDashboard/SubscribersManagement";
import {
  dashboardSingleTabStyle,
  dashboardTabsStyle,
  inboxNotificationBadge,
  whatsNew,
} from "../../Styles/Styles";
import ImagesManagement from "./SuperAdminDashboard/ImagesManagement/Index";
import AdsReports from "./SuperAdminDashboard/AdsReportsManagement";
import AdminLiveChatMonitor from "./SuperAdminDashboard/AdminLiveChatMonitor/Index";
import DatabaseBackup from "./SuperAdminDashboard/DatabaseBackup/Index";

export default function Sidebar() {
  const [tabIndex, setTabIndex] = useState(); // Start from 1 (first regular tab)
  const [adminTabIndex, setAdminTabIndex] = useState(); // Start admin tab at 1 (first admin tab)
  const [unreadNotifications, setUnreadNotifications] = useState(0); // Start admin tab at 1 (first admin tab)
  const [unreadMessages, setUnreadMessages] = useState(0); // Track unread messages count
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));

  const userRole = user?.role;

  const fetchUnreadNotifications = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/notifications/unread`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Include user token
          },
        }
      );
      const data = await response.json();
      setUnreadNotifications(data.unreadCount);
    } catch (error) {
      console.error("Error fetching unread notifications:", error);
    }
  };

  const fetchUnreadMessages = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/chat/unread-count`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Include user token
          },
        }
      );
      const data = await response.json();
      setUnreadMessages(data.unreadCount);
    } catch (error) {
      console.error("Error fetching unread messages:", error);
    }
  };

  useEffect(() => {
    const path = location.pathname;
    console.log(path);
    console.log("tabIndex", tabIndex);
    console.log("adminTabIndex", adminTabIndex);
    fetchUnreadNotifications();
    fetchUnreadMessages(); // Fetch unread messages on load
    // Handle the regular user routes
    if (path.startsWith("/admin")) {
      setTabIndex(undefined); // Ensure regular tab index is reset for admin routes
      // Handle admin routes
      if (path === "/admin/ads-management") {
        setAdminTabIndex(0);
      } else if (path === "/admin/users-management") {
        setAdminTabIndex(1);
      } else if (path === "/admin/categories-management") {
        setAdminTabIndex(2);
      } else if (path === "/admin/searches-management") {
        setAdminTabIndex(3);
      } else if (path === "/admin/services-management") {
        setAdminTabIndex(4);
      } else if (path === "/admin/experts-management") {
        setAdminTabIndex(5);
      } else if (path === "/admin/deleted-ads-management") {
        setAdminTabIndex(6);
      } else if (path === "/admin/users-ids-management") {
        setAdminTabIndex(7);
      } else if (path === "/admin/contact-form") {
        setAdminTabIndex(8);
      } else if (path === "/admin/subscribers") {
        setAdminTabIndex(9);
      } else if (path === "/admin/images-management") {
        setAdminTabIndex(10);
      } else if (path === "/admin/reports") {
        setAdminTabIndex(11);
      } else if (path === "/admin/live-chat") {
        setAdminTabIndex(12);
      } else if (path === "/admin/database-backup") {
        setAdminTabIndex(13);
      }
    } else {
      // Handle regular user routes
      setAdminTabIndex(undefined); // Reset admin tab index for regular routes
      if (path === "/dashboard") {
        setTabIndex(0);
      } else if (path === "/inbox") {
        setTabIndex(1);
      } else if (path === "/notifications") {
        setTabIndex(2);
      } else if (path === "/my-ads") {
        setTabIndex(3);
      } else if (path === "/offers") {
        setTabIndex(4);
      } else if (path === "/my-favorites") {
        setTabIndex(5);
      } else if (path === "/profile") {
        setTabIndex(6);
      } else if (path === "/my-services") {
        setTabIndex(7);
      } else if (path === "/whats-new") {
        setTabIndex(8);
      }
    }
  }, [location.pathname]);

  // Reset tabIndex to 0 if any admin tab is selected
  useEffect(() => {
    if (adminTabIndex >= 0) {
      setTabIndex(); // Reset regular user tab index to 0 when an admin tab is selected
    }
  }, [adminTabIndex]);

  useEffect(() => {
    if (tabIndex >= 0) {
      setAdminTabIndex(); // Reset admin tab index to 0 when a regular user tab is selected
    }
  }, [tabIndex]);

  if (!user) {
    return <div className="dashboard-container">User not found</div>;
  }

  // Handle regular user tab change
  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
    switch (newTabIndex) {
      case 0:
        navigate("/dashboard");
        break;
      case 1:
        navigate("/inbox");
        break;
      case 2:
        navigate("/notifications");
        break;
      case 3:
        navigate("/my-ads");
        break;
      case 4:
        navigate("/offers");
        break;
      case 5:
        navigate("/my-favorites");
        break;
      case 6:
        navigate("/profile");
        break;
      case 7:
        navigate("/my-services");
        break;
      case 8:
        navigate("/whats-new");
        break;
      default:
        navigate("/dashboard");
        break;
    }
  };

  // Handle superAdmin tab change
  const handleAdminTabChange = (event, newAdminTabIndex) => {
    setAdminTabIndex(newAdminTabIndex);
    switch (newAdminTabIndex) {
      case 0:
        navigate("/admin/ads-management");
        break;
      case 1:
        navigate("/admin/users-management");
        break;
      case 2:
        navigate("/admin/categories-management");
        break;
      case 3:
        navigate("/admin/searches-management");
        break;
      case 4:
        navigate("/admin/services-management");
        break;
      case 5:
        navigate("/admin/experts-management");
        break;
      case 6:
        navigate("/admin/deleted-ads-management");
        break;
      case 7:
        navigate("/admin/users-ids-management");
        break;
      case 8:
        navigate("/admin/contact-form");
        break;
      case 9:
        navigate("/admin/subscribers");
        break;
      case 10:
        navigate("/admin/images-management");
        break;
      case 11:
        navigate("/admin/reports");
        break;
      case 12:
        navigate("/admin/live-chat");
        break;
      case 13:
        navigate("/admin/database-backup");
        break;
      default:
        navigate("/dashboard");
        break;
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* Left Sidebar for Tabs */}
      <Box
        sx={{
          display: { xs: "none", sm: "none", md: "block" }, // Full width on extra-small screens, then 200px for small screens, and 250px for medium and up
          width: { md: "250px" }, // Full width on extra-small screens, then 200px for small screens, and 250px for medium and up
          borderRight: { xs: "none", sm: "1px solid #ddd" }, // Remove the border on extra-small screens
          height: { xs: "auto", sm: "100vh" }, // Automatic height on small screens, full height on larger screens
          position: { xs: "relative", sm: "sticky", md: "sticky" }, // No sticky positioning on extra-small screens
          top: 0,
          alignSelf: "flex-start",
          padding: { xs: 1, sm: 2 }, // Adjust padding for smaller screens
          overflowY: "auto", // Add overflow to allow scrolling if needed
          backgroundColor: "background.paper", // Background color to differentiate sidebar
          flexShrink: 0,
        }}
      >
        {/* Regular Tabs for all users */}
        <Tabs
          orientation="vertical"
          value={tabIndex}
          onChange={handleTabChange}
          aria-label="Regular user tabs"
          sx={{ ...dashboardTabsStyle }}
        >
          <Tab label="DASHBOARD" sx={{ ...dashboardSingleTabStyle }} />
          <Tab
            label={
              <Badge
                color="error"
                variant="dot"
                invisible={unreadMessages === 0} // Hide dot if unreadCount is 0
                sx={{ ...inboxNotificationBadge }}
              >
                Inbox
              </Badge>
            }
            sx={{ ...dashboardSingleTabStyle }}
          />
          <Tab
            label={
              <Badge
                color="error"
                variant="dot"
                invisible={unreadNotifications === 0} // Hide dot if unreadCount is 0
                sx={{ ...inboxNotificationBadge }}
              >
                Notifications
              </Badge>
            }
            sx={{ ...dashboardSingleTabStyle }}
          />
          <Tab label="MY ADS" sx={{ ...dashboardSingleTabStyle }} />
          <Tab label="MY OFFERS" sx={{ ...dashboardSingleTabStyle }} />
          <Tab label="My Favorites" sx={{ ...dashboardSingleTabStyle }} />
          <Tab label="User Profile" sx={{ ...dashboardSingleTabStyle }} />
          <Tab label="Business Profile" sx={{ ...dashboardSingleTabStyle }} />
          <Tab label="What's New" sx={{ ...whatsNew }} />
        </Tabs>

        {/* SuperAdmin Tabs */}
        {userRole === "superAdmin" && (
          <Tabs
            orientation="vertical"
            value={adminTabIndex}
            onChange={handleAdminTabChange}
            aria-label="SuperAdmin tabs"
            sx={{ ...dashboardTabsStyle }}
          >
            <Tab label="Ads Management" sx={{ ...dashboardSingleTabStyle }} />
            <Tab label="Users Management" sx={{ ...dashboardSingleTabStyle }} />
            <Tab
              label="Categories Management"
              sx={{ ...dashboardSingleTabStyle }}
            />
            <Tab
              label="Searches Management"
              sx={{ ...dashboardSingleTabStyle }}
            />
            <Tab
              label="Services Management"
              sx={{ ...dashboardSingleTabStyle }}
            />
            <Tab
              label="Service Providers Management"
              sx={{ ...dashboardSingleTabStyle }}
            />
            <Tab
              label="Deleted Ads Management"
              sx={{ ...dashboardSingleTabStyle }}
            />
            <Tab
              label="User IDs Management"
              sx={{ ...dashboardSingleTabStyle }}
            />
            <Tab label="Contact Form" sx={{ ...dashboardSingleTabStyle }} />
            <Tab label="Subscribers" sx={{ ...dashboardSingleTabStyle }} />
            <Tab
              label="Images Management"
              sx={{ ...dashboardSingleTabStyle }}
            />
            <Tab
              label="Reports Management"
              sx={{ ...dashboardSingleTabStyle }}
            />
            <Tab
              label="Live Chat Monitor"
              sx={{ ...dashboardSingleTabStyle }}
            />
            <Tab label="Database Backup" sx={{ ...dashboardSingleTabStyle }} />
          </Tabs>
        )}
      </Box>

      {/* Right Content */}
      <Box
        sx={{
          // flexGrow: 1,
          width: { xs: "100%", sm: "100%", md: "calc(100% - 250px)" },
        }}
      >
        <Routes>
          <Route
            path="/dashboard"
            element={
              <Dashboard
                unreadNotifications={unreadNotifications}
                unreadMessages={unreadMessages}
              />
            }
          />
          <Route path="/my-ads" element={<MyAds />} />
          <Route path="/my-services" element={<MyServices />} />
          <Route path="/my-favorites" element={<Favorites />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/inbox" element={<Inbox userId={user._id} />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/whats-new" element={<WhatsNew />} />
          {/* Admin Routes */}
          <Route path="/admin/users-management" element={<UserManagement />} />
          <Route
            path="/admin/categories-management"
            element={<CategoryManagement />}
          />
          <Route path="/admin/ads-management" element={<AdsManagement />} />
          <Route
            path="/admin/searches-management"
            element={<SearchesManagement />}
          />
          <Route
            path="/admin/deleted-ads-management"
            element={<DeletedAdsManagement />}
          />
          <Route
            path="/admin/services-management"
            element={<ServicesManagement />}
          />
          <Route
            path="/admin/experts-management"
            element={<ServiceProvidersManagement />}
          />
          <Route
            path="/admin/users-ids-management"
            element={<IDsManagement />}
          />
          <Route path="/admin/blogs-management" element={<BlogsManagement />} />
          <Route
            path="/admin/contact-form"
            element={<ContactFormEntriesManagement />}
          />
          <Route
            path="/admin/subscribers"
            element={<SubscribersManagement />}
          />
          <Route
            path="/admin/images-management"
            element={<ImagesManagement />}
          />
          <Route path="/admin/reports" element={<AdsReports />} />
          <Route path="/admin/live-chat" element={<AdminLiveChatMonitor />} />
          <Route path="/admin/database-backup" element={<DatabaseBackup />} />
        </Routes>
      </Box>
    </Box>
  );
}
